// Personnel Costs Detail Data
export const personnelCostsData = {
  2024: {
    totalCost: 54.2, weightInOpex: 32.8, yoyChange: 8.2, vsBudget: 3.5, headcount: 1842, avgCostPerEmployee: 29.4,
    headcountByFunction: [
      { function: { pt: 'Projectos', en: 'Projects' }, count: 145, percentage: 7.9 },
      { function: { pt: 'Direcção de Op. Mineiras', en: 'Mining Operations Management' }, count: 285, percentage: 15.5 },
      { function: { pt: 'Geologia', en: 'Geology' }, count: 178, percentage: 9.7 },
      { function: { pt: 'Exploração', en: 'Exploration' }, count: 256, percentage: 13.9 },
      { function: { pt: 'IT', en: 'IT' }, count: 42, percentage: 2.3 },
      { function: { pt: 'Metalurgia', en: 'Metallurgy' }, count: 198, percentage: 10.7 },
      { function: { pt: 'Engenharia', en: 'Engineering' }, count: 134, percentage: 7.3 },
      { function: { pt: 'Segurança Industrial', en: 'Industrial Safety' }, count: 89, percentage: 4.8 },
      { function: { pt: 'Perfuração e Explosivos', en: 'Drilling & Explosives' }, count: 167, percentage: 9.1 },
      { function: { pt: 'HSE', en: 'HSE' }, count: 76, percentage: 4.1 },
      { function: { pt: 'Administração e Serviços', en: 'Administration & Services' }, count: 112, percentage: 6.1 },
      { function: { pt: 'Topografia', en: 'Topography' }, count: 58, percentage: 3.1 },
      { function: { pt: 'Planeamento', en: 'Planning' }, count: 45, percentage: 2.4 },
      { function: { pt: 'Outros', en: 'Others' }, count: 57, percentage: 3.1 },
    ],
    costByArea: [
      { area: { pt: 'Exploração', en: 'Exploration' }, cost: 22.8, percentage: 42.1, headcount: 682 },
      { area: { pt: 'Geologia', en: 'Geology' }, cost: 7.5, percentage: 13.8, headcount: 223 },
      { area: { pt: 'Metalurgia', en: 'Metallurgy' }, cost: 10.5, percentage: 19.4, headcount: 312 },
      { area: { pt: 'Perfuração e Explosivos', en: 'Drilling & Explosives' }, cost: 6.7, percentage: 12.4, headcount: 198 },
      { area: { pt: 'Suporte (Luanda)', en: 'Support (Luanda)' }, cost: 3.5, percentage: 6.5, headcount: 147 },
      { area: { pt: 'Suporte (Mina)', en: 'Support (Mine)' }, cost: 3.2, percentage: 5.9, headcount: 280 },
    ],
    costPerUnit: { perTonMoved: 4.52, perTonProcessed: 22.58, perCaratProduced: 49.27 },
    fixedVsVariable: { fixed: { value: 42.8, percentage: 79.0 }, variable: { value: 11.4, percentage: 21.0 } },
    costComposition: [
      { component: { pt: 'Remunerações - Órgãos Sociais', en: 'Management Remuneration' }, value: 3.2, percentage: 5.9 },
      { component: { pt: 'Remunerações - Pessoal', en: 'Staff Remuneration' }, value: 32.5, percentage: 60.0 },
      { component: { pt: 'Encargos sobre remunerações', en: 'Payroll Charges' }, value: 6.5, percentage: 12.0 },
      { component: { pt: 'Seguros de acidente trabalho', en: 'Work Accident Insurance' }, value: 2.2, percentage: 4.0 },
      { component: { pt: 'Formação', en: 'Training' }, value: 1.6, percentage: 3.0 },
      { component: { pt: 'Seguro de saúde', en: 'Health Insurance' }, value: 3.8, percentage: 7.0 },
      { component: { pt: 'Bens alimentares e refeições', en: 'Food & Meals' }, value: 2.7, percentage: 5.0 },
      { component: { pt: 'Outras despesas com pessoal', en: 'Other Personnel Expenses' }, value: 1.7, percentage: 3.1 },
    ],
    monthlyData: [
      { month: 'Jan', cost: 4.2, headcount: 1820, budget: 4.0 },
      { month: 'Feb', cost: 4.3, headcount: 1825, budget: 4.1 },
      { month: 'Mar', cost: 4.4, headcount: 1830, budget: 4.2 },
      { month: 'Apr', cost: 4.5, headcount: 1835, budget: 4.3 },
      { month: 'May', cost: 4.6, headcount: 1838, budget: 4.3 },
      { month: 'Jun', cost: 4.5, headcount: 1840, budget: 4.4 },
      { month: 'Jul', cost: 4.5, headcount: 1842, budget: 4.4 },
      { month: 'Aug', cost: 4.6, headcount: 1842, budget: 4.5 },
      { month: 'Sep', cost: 4.5, headcount: 1842, budget: 4.5 },
      { month: 'Oct', cost: 4.7, headcount: 1842, budget: 4.5 },
      { month: 'Nov', cost: 4.6, headcount: 1842, budget: 4.5 },
      { month: 'Dec', cost: 4.8, headcount: 1842, budget: 4.6 },
    ],
    directVsIndirect: { direct: { count: 1417, percentage: 77.0 }, indirect: { count: 425, percentage: 23.0 } },
    overtimeRatio: 10.0,
    productionPerEmployee: 597,
    yoyWaterfall: [
      { name: { pt: '2023', en: '2023' }, value: 50.1, type: 'start' },
      { name: { pt: 'Aumento Headcount', en: 'Headcount Increase' }, value: 1.8, type: 'increase' },
      { name: { pt: 'Revisão Salarial', en: 'Salary Revision' }, value: 1.2, type: 'increase' },
      { name: { pt: 'Horas Extra', en: 'Overtime' }, value: 0.6, type: 'increase' },
      { name: { pt: 'Prémios', en: 'Bonuses' }, value: 0.8, type: 'increase' },
      { name: { pt: 'Eficiências', en: 'Efficiencies' }, value: -0.3, type: 'decrease' },
      { name: { pt: '2024', en: '2024' }, value: 54.2, type: 'end' },
    ],
  },
  2025: {
    totalCost: 65.0, weightInOpex: 33.2, yoyChange: 19.9, vsBudget: 5.2, headcount: 1956, avgCostPerEmployee: 33.2,
    headcountByFunction: [
      { function: { pt: 'Projectos', en: 'Projects' }, count: 154, percentage: 7.9 },
      { function: { pt: 'Direcção de Op. Mineiras', en: 'Mining Operations Management' }, count: 302, percentage: 15.4 },
      { function: { pt: 'Geologia', en: 'Geology' }, count: 189, percentage: 9.7 },
      { function: { pt: 'Exploração', en: 'Exploration' }, count: 272, percentage: 13.9 },
      { function: { pt: 'IT', en: 'IT' }, count: 45, percentage: 2.3 },
      { function: { pt: 'Metalurgia', en: 'Metallurgy' }, count: 210, percentage: 10.7 },
      { function: { pt: 'Engenharia', en: 'Engineering' }, count: 142, percentage: 7.3 },
      { function: { pt: 'Segurança Industrial', en: 'Industrial Safety' }, count: 95, percentage: 4.9 },
      { function: { pt: 'Perfuração e Explosivos', en: 'Drilling & Explosives' }, count: 178, percentage: 9.1 },
      { function: { pt: 'HSE', en: 'HSE' }, count: 81, percentage: 4.1 },
      { function: { pt: 'Administração e Serviços', en: 'Administration & Services' }, count: 119, percentage: 6.1 },
      { function: { pt: 'Topografia', en: 'Topography' }, count: 62, percentage: 3.2 },
      { function: { pt: 'Planeamento', en: 'Planning' }, count: 48, percentage: 2.5 },
      { function: { pt: 'Outros', en: 'Others' }, count: 59, percentage: 3.0 },
    ],
    costByArea: [
      { area: { pt: 'Exploração', en: 'Exploration' }, cost: 27.3, percentage: 42.0, headcount: 724 },
      { area: { pt: 'Geologia', en: 'Geology' }, cost: 8.0, percentage: 12.3, headcount: 237 },
      { area: { pt: 'Metalurgia', en: 'Metallurgy' }, cost: 11.1, percentage: 17.1, headcount: 330 },
      { area: { pt: 'Perfuração e Explosivos', en: 'Drilling & Explosives' }, cost: 7.1, percentage: 10.9, headcount: 211 },
      { area: { pt: 'Suporte (Luanda)', en: 'Support (Luanda)' }, cost: 5.3, percentage: 8.2, headcount: 156 },
      { area: { pt: 'Suporte (Mina)', en: 'Support (Mine)' }, cost: 6.2, percentage: 9.5, headcount: 298 },
    ],
    costPerUnit: { perTonMoved: 4.88, perTonProcessed: 24.07, perCaratProduced: 52.42 },
    fixedVsVariable: { fixed: { value: 51.4, percentage: 79.1 }, variable: { value: 13.6, percentage: 20.9 } },
    costComposition: [
      { component: { pt: 'Remunerações - Órgãos Sociais', en: 'Management Remuneration' }, value: 3.8, percentage: 5.8 },
      { component: { pt: 'Remunerações - Pessoal', en: 'Staff Remuneration' }, value: 39.0, percentage: 60.0 },
      { component: { pt: 'Encargos sobre remunerações', en: 'Payroll Charges' }, value: 7.8, percentage: 12.0 },
      { component: { pt: 'Seguros de acidente trabalho', en: 'Work Accident Insurance' }, value: 2.6, percentage: 4.0 },
      { component: { pt: 'Formação', en: 'Training' }, value: 2.0, percentage: 3.1 },
      { component: { pt: 'Seguro de saúde', en: 'Health Insurance' }, value: 4.5, percentage: 6.9 },
      { component: { pt: 'Bens alimentares e refeições', en: 'Food & Meals' }, value: 3.3, percentage: 5.1 },
      { component: { pt: 'Outras despesas com pessoal', en: 'Other Personnel Expenses' }, value: 2.0, percentage: 3.1 },
    ],
    monthlyData: [
      { month: 'Jan', cost: 5.0, headcount: 1860, budget: 4.8 },
      { month: 'Feb', cost: 5.1, headcount: 1875, budget: 4.9 },
      { month: 'Mar', cost: 5.2, headcount: 1890, budget: 5.0 },
      { month: 'Apr', cost: 5.3, headcount: 1905, budget: 5.0 },
      { month: 'May', cost: 5.4, headcount: 1920, budget: 5.1 },
      { month: 'Jun', cost: 5.5, headcount: 1935, budget: 5.1 },
      { month: 'Jul', cost: 5.5, headcount: 1945, budget: 5.2 },
      { month: 'Aug', cost: 5.6, headcount: 1950, budget: 5.2 },
      { month: 'Sep', cost: 5.5, headcount: 1952, budget: 5.3 },
      { month: 'Oct', cost: 5.6, headcount: 1954, budget: 5.3 },
      { month: 'Nov', cost: 5.6, headcount: 1955, budget: 5.4 },
      { month: 'Dec', cost: 5.7, headcount: 1956, budget: 5.4 },
    ],
    directVsIndirect: { direct: { count: 1504, percentage: 76.9 }, indirect: { count: 452, percentage: 23.1 } },
    overtimeRatio: 11.1,
    productionPerEmployee: 634,
    yoyWaterfall: [
      { name: { pt: '2024', en: '2024' }, value: 54.2, type: 'start' },
      { name: { pt: 'Aumento Headcount', en: 'Headcount Increase' }, value: 3.8, type: 'increase' },
      { name: { pt: 'Revisão Salarial', en: 'Salary Revision' }, value: 2.8, type: 'increase' },
      { name: { pt: 'Horas Extra', en: 'Overtime' }, value: 1.8, type: 'increase' },
      { name: { pt: 'Prémios', en: 'Bonuses' }, value: 2.2, type: 'increase' },
      { name: { pt: 'Eficiências', en: 'Efficiencies' }, value: 0.2, type: 'increase' },
      { name: { pt: '2025', en: '2025' }, value: 65.0, type: 'end' },
    ],
  },
  2026: {
    totalCost: 68.5, weightInOpex: 33.5, yoyChange: 5.4, vsBudget: 2.1, headcount: 1998, avgCostPerEmployee: 34.3,
    headcountByFunction: [
      { function: { pt: 'Projectos', en: 'Projects' }, count: 158, percentage: 7.9 },
      { function: { pt: 'Direcção de Op. Mineiras', en: 'Mining Operations Management' }, count: 309, percentage: 15.5 },
      { function: { pt: 'Geologia', en: 'Geology' }, count: 193, percentage: 9.7 },
      { function: { pt: 'Exploração', en: 'Exploration' }, count: 278, percentage: 13.9 },
      { function: { pt: 'IT', en: 'IT' }, count: 46, percentage: 2.3 },
      { function: { pt: 'Metalurgia', en: 'Metallurgy' }, count: 215, percentage: 10.8 },
      { function: { pt: 'Engenharia', en: 'Engineering' }, count: 145, percentage: 7.3 },
      { function: { pt: 'Segurança Industrial', en: 'Industrial Safety' }, count: 97, percentage: 4.9 },
      { function: { pt: 'Perfuração e Explosivos', en: 'Drilling & Explosives' }, count: 182, percentage: 9.1 },
      { function: { pt: 'HSE', en: 'HSE' }, count: 83, percentage: 4.2 },
      { function: { pt: 'Administração e Serviços', en: 'Administration & Services' }, count: 122, percentage: 6.1 },
      { function: { pt: 'Topografia', en: 'Topography' }, count: 63, percentage: 3.2 },
      { function: { pt: 'Planeamento', en: 'Planning' }, count: 49, percentage: 2.5 },
      { function: { pt: 'Outros', en: 'Others' }, count: 58, percentage: 2.9 },
    ],
    costByArea: [
      { area: { pt: 'Exploração', en: 'Exploration' }, cost: 28.8, percentage: 42.0, headcount: 739 },
      { area: { pt: 'Geologia', en: 'Geology' }, cost: 8.2, percentage: 12.0, headcount: 242 },
      { area: { pt: 'Metalurgia', en: 'Metallurgy' }, cost: 11.4, percentage: 16.6, headcount: 338 },
      { area: { pt: 'Perfuração e Explosivos', en: 'Drilling & Explosives' }, cost: 7.3, percentage: 10.7, headcount: 216 },
      { area: { pt: 'Suporte (Luanda)', en: 'Support (Luanda)' }, cost: 5.9, percentage: 8.6, headcount: 160 },
      { area: { pt: 'Suporte (Mina)', en: 'Support (Mine)' }, cost: 6.9, percentage: 10.1, headcount: 303 },
    ],
    costPerUnit: { perTonMoved: 5.02, perTonProcessed: 25.18, perCaratProduced: 54.80 },
    fixedVsVariable: { fixed: { value: 54.1, percentage: 79.0 }, variable: { value: 14.4, percentage: 21.0 } },
    costComposition: [
      { component: { pt: 'Remunerações - Órgãos Sociais', en: 'Management Remuneration' }, value: 4.1, percentage: 6.0 },
      { component: { pt: 'Remunerações - Pessoal', en: 'Staff Remuneration' }, value: 41.1, percentage: 60.0 },
      { component: { pt: 'Encargos sobre remunerações', en: 'Payroll Charges' }, value: 8.2, percentage: 12.0 },
      { component: { pt: 'Seguros de acidente trabalho', en: 'Work Accident Insurance' }, value: 2.7, percentage: 4.0 },
      { component: { pt: 'Formação', en: 'Training' }, value: 2.1, percentage: 3.0 },
      { component: { pt: 'Seguro de saúde', en: 'Health Insurance' }, value: 4.8, percentage: 7.0 },
      { component: { pt: 'Bens alimentares e refeições', en: 'Food & Meals' }, value: 3.4, percentage: 5.0 },
      { component: { pt: 'Outras despesas com pessoal', en: 'Other Personnel Expenses' }, value: 2.1, percentage: 3.0 },
    ],
    monthlyData: [
      { month: 'Jan', cost: 5.5, headcount: 1960, budget: 5.4 },
      { month: 'Feb', cost: 5.6, headcount: 1968, budget: 5.5 },
      { month: 'Mar', cost: 5.7, headcount: 1975, budget: 5.5 },
      { month: 'Apr', cost: 5.7, headcount: 1980, budget: 5.6 },
      { month: 'May', cost: 5.7, headcount: 1985, budget: 5.6 },
      { month: 'Jun', cost: 5.7, headcount: 1988, budget: 5.6 },
      { month: 'Jul', cost: 5.7, headcount: 1990, budget: 5.7 },
      { month: 'Aug', cost: 5.8, headcount: 1992, budget: 5.7 },
      { month: 'Sep', cost: 5.7, headcount: 1994, budget: 5.7 },
      { month: 'Oct', cost: 5.8, headcount: 1996, budget: 5.7 },
      { month: 'Nov', cost: 5.8, headcount: 1997, budget: 5.8 },
      { month: 'Dec', cost: 5.8, headcount: 1998, budget: 5.8 },
    ],
    directVsIndirect: { direct: { count: 1537, percentage: 76.9 }, indirect: { count: 461, percentage: 23.1 } },
    overtimeRatio: 11.0,
    productionPerEmployee: 626,
    yoyWaterfall: [
      { name: { pt: '2025', en: '2025' }, value: 65.0, type: 'start' },
      { name: { pt: 'Aumento Headcount', en: 'Headcount Increase' }, value: 1.4, type: 'increase' },
      { name: { pt: 'Revisão Salarial', en: 'Salary Revision' }, value: 1.5, type: 'increase' },
      { name: { pt: 'Horas Extra', en: 'Overtime' }, value: 0.3, type: 'increase' },
      { name: { pt: 'Prémios', en: 'Bonuses' }, value: 0.5, type: 'increase' },
      { name: { pt: 'Eficiências', en: 'Efficiencies' }, value: -0.2, type: 'decrease' },
      { name: { pt: '2026', en: '2026' }, value: 68.5, type: 'end' },
    ],
  },
};
